import React from 'react';
import c from 'classnames';
import PlainButtonOrLink, { Props as ButtonProps } from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import ActionBarItemContentWrapper from '../ActionBarItemContentWrapper';
import s from './ActionBarButton.scss';

export interface Props extends ButtonProps {
  dataHook?: string;
}

/**
 * A button for our `ActionBar`.
 */
const ActionBarButton: React.FC<Props> = ({ className, dataHook, children, ...rest }) => (
  <PlainButtonOrLink className={c(s['root'], className)} data-hook={dataHook} {...rest}>
    <ActionBarItemContentWrapper>{children}</ActionBarItemContentWrapper>
  </PlainButtonOrLink>
);

ActionBarButton.displayName = 'ActionBarButton';

export default ActionBarButton;
